import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { Platform } from '@ionic/angular';

import { throwError } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';

import { environment } from 'src/environments/environment';
import { HttpHeadersHelper } from 'src/app/helpers/headers';

@Injectable({
  providedIn: 'root'
})

export class AuthService {
  isLoggedIn = false;
  token: any;

  protected apiUrl = environment.apiUrl;

  constructor(
    private http: HttpClient,
    private storage: Storage,
    private platform: Platform,
  ) { }

  login(email: String, password: String) {
    // console.log('login(): Entering');

    return this.http.post(this.apiUrl + '/login', {
      email: email,
      password: password,
      platforms: this.platform.platforms()
    }, {
      headers: HttpHeadersHelper.createHeaders(this.token),
      withCredentials: false
    }).pipe(
      tap((data: { success?: { token: string }, error?: string }) => {
        if (data.error) { throw data; }
        this.setToken(data.success.token);
        return this.token;
      }),
      catchError((err) => {
        const error = err instanceof HttpErrorResponse ? err.error : err;
        console.error('login():', error);
        return throwError(error);
      }),
    );
  }

  logout() {
    // console.log('logout(): Entering');
    this.storage.remove('token')
    .then(() => {
      // console.log('logout(): Token removed');
    })
    .catch((reason) => {
      console.error('logout(): Token was not removed:', reason);
    });

    this.isLoggedIn = false;
    delete this.token;
  }

  setToken(token: string) {
    this.storage.set('token', token)
    .then(
      () => {
        // console.log('setToken(): Token Stored: ', token);
      },
      error => console.error('setToken(): Error storing item', error)
    );
    this.token = token;
    this.isLoggedIn = true;
  }

  public async getToken(): Promise<string | void> {
    // console.log('getToken(): Entering: '); // , this.token);

    try {
      if (this.token === undefined || this.token === null) {
        const data = await this.storage.get('token');
        this.token = data;
        if (this.token !== null) {
          // console.log('getToken(): Token was read from storage');
          this.isLoggedIn = true;
        } else {
          this.isLoggedIn = false;
        }
      }
    } catch (error) {
      console.error('getToken(): Error reading token from storage');
      this.token = null;
      this.isLoggedIn = false;
    }

    return new Promise<string | void>((resolve, reject) => {
      resolve(this.token);
    });
  }
}
